import React from 'react'
import { Button, Container } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
function HomeCTA() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  return (
    <>
     <div className="home-cta common-padding">
      <Container>
        <div className='home-cta-wrap'>
          <div className='text-wrap'>
            <h2>Get home recommendations</h2>
            {token ? (
              <p>Browse your favorite listings.</p>
            ) : (
              <p>Sign in for a more personalized experience.</p>
            )}
          </div>
          {!token && (
            <Button className='custom-bttn style-1 ml-20' onClick={() => navigate("/sign-in")}>Sign In / Register</Button>
          )}
        </div>
      </Container>
     </div>
    </>
  )
}
export default HomeCTA